import { Empty } from "components/core/Empty";
import { ContentGridMixContentQuery } from "components/domain/contents/ContentGridMixContentQuery";
import { ContentGridQuery } from "components/domain/contents/ContentGridQuery";
import { useAuth } from "hooks/useAuth";
import { ComponentProps } from "react";
import { ContentSection } from "types/app";
import { LIMIT } from "utils/buildQueryVariables";

import { Section } from ".";
import { useMixArchives } from "../hooks/useMixArchives";

export const MixedSection = ({
    contentSection,
    variables,
    limit = LIMIT.default,
    className,
    ...props
}: Omit<
    ComponentProps<
        typeof ContentGridQuery<MixContentQuery, MixContentQueryVariables>
    >,
    "useQuery" | "extractor" | "updateQuery"
> & {
    className?: string;
    contentSection: ContentSection;
    variables: MixContentQueryVariables;
}) => {
    const { me } = useAuth();
    const isGuest = !me;

    const { archives, archiveTagEnums, archivesLoading } = useMixArchives();

    return (
        <Section className={className} {...props}>
            <ContentGridMixContentQuery
                type="mixed"
                contentSection={contentSection}
                limit={limit}
                variables={variables}
                archives={archives}
                archiveTagEnums={archiveTagEnums}
                archivesLoading={archivesLoading}
                isGuest={isGuest}
                empty={
                    <Empty
                        imgurl="/img/content-empty.png"
                        mainText="추천할 만한 콘텐츠를 열심히 찾고 있어요."
                        subText="조금만 기다려 주세요!"
                    />
                }
            />
        </Section>
    );
};
